import { useRef, useState } from 'react';

export function intersectingAnomalies(candidates, box) {
  return candidates.filter(candidate => candidate.reviewStatus !== 'DISMISSED' && candidate.box.x1 <= box.x2 && candidate.box.x2 >= box.x1 && candidate.box.y1 <= box.y2 && candidate.box.y2 >= box.y1).map(candidate => candidate.id);
}

export default function AnomalySelection({ rect, candidates = [], onSelect, onArea }) {
  const anchor = useRef(null);
  const [draft, setDraft] = useState(null);
  const point = event => {
    // The DOM bounds include the thermal viewport's zoom and pan.
    const bounds = event.currentTarget.getBoundingClientRect();
    return { x: Math.max(0, Math.min(1, (event.clientX - bounds.left) / bounds.width)), y: Math.max(0, Math.min(1, (event.clientY - bounds.top) / bounds.height)) };
  };
  const box = (a, b) => ({ x1: Math.min(a.x,b.x), y1: Math.min(a.y,b.y), x2: Math.max(a.x,b.x), y2: Math.max(a.y,b.y) });
  const cancel = () => { anchor.current = null; setDraft(null); };
  return <div className="solar-selection-input" aria-label={onArea ? "Draw manual anomaly" : "Select anomalies by rectangle"} style={{ left: rect.left, top: rect.top, width: rect.width, height: rect.height }}
    onMouseDown={event => event.stopPropagation()} onMouseMove={event => event.stopPropagation()}
    onWheel={event => event.stopPropagation()}
    onPointerDown={event => {
      if (event.button !== 0) return;
      event.preventDefault(); event.stopPropagation();
      anchor.current = point(event); setDraft(null); event.currentTarget.setPointerCapture(event.pointerId);
    }}
    onPointerMove={event => { if (anchor.current) setDraft(box(anchor.current,point(event))); }}
    onPointerUp={event => {
      if (!anchor.current) return;
      const bounds = box(anchor.current,point(event)); cancel();
      if (bounds.x2 > bounds.x1 && bounds.y2 > bounds.y1) { if(onArea) onArea(bounds); else onSelect(intersectingAnomalies(candidates,bounds)); }
    }} onPointerCancel={cancel} onLostPointerCapture={cancel}>
    {draft && <div className="solar-selection-box" style={{ left: `${draft.x1*100}%`, top: `${draft.y1*100}%`, width: `${(draft.x2-draft.x1)*100}%`, height: `${(draft.y2-draft.y1)*100}%` }} />}
  </div>;
}
